<template>
    <div>
        <div class="panel animated fadeInRightBig">
            <div class="panel-heading">
                <div class="panel-title">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="title">
                                <b>{{ user.paper.name }}</b> - {{ user.name }}

                                <i class="fa fa-user-circle" style="float:right;margin-top:6px;font-size:21px;"></i>
                            </span>

                            <hr class="m-t-md">
                        </div>

                        <div class="col-md-2 text-right">
                            <div class="img-responsive">
                                <img :src="user.picture" width="160px" @error="imageLoadError">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="block" style="padding:5px 25px 25px 25px">
                                <span class="block m-t-sm">
                                    <b>Nome:</b> {{ user.name }}
                                </span>

                                <span class="block m-t-sm">
                                    <b>CPF:</b> {{ (user.cpf) ? user.cpf : 'Não definido' }}
                                </span>

                                <span class="block m-t-sm">
                                    <b>E-mail:</b> {{ user.email }}
                                </span>

                                <span class="block m-t-sm">
                                    <b>Criado em:</b> {{ (user.created_at) ? user.created_at : 'Não definido' }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <hr class="m-t-lg">

                    <div class="block text-right">
                        <router-link to="/admin" class="btn btn-info m-r-sm m-b-sm">
                            <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                user: {
                    paper: {}
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            getUser: function(){
                let self = this;
                let id   = self.$route.params.id;
                let api  = self.$store.state.api + 'user/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.user = response.data;

                        self.user.picture = self.user.picture + '?' + self.makeid();
                    })
                    .catch((error) => {
                        self.errors = error.response.data;
                        self.$message(null, self.errors, 'error');
                    });
            },
            makeid() {
                let text = '';
                let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

                for (let i = 0; i < 5; i++)
                    text += possible.charAt(Math.floor(Math.random() * possible.length));

                return text;
            },
            imageLoadError(){
                this.user.picture = '/static/blank-profile-picture.png';
            }
        },
        mounted: function(){
            this.getUser();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Admin/View.vue